module.exports = __webpack_public_path__ + "static/img/guide-06.a902214b.png";